var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.4 39.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#06233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.6,31.6c-.4,0-.7,.1-1.1,.2L26.7,2.7c-.8-1.7-2.3-2.7-3.9-2.7h0c-1.7,0-3.1,1-3.9,2.7L5,31.8c-.3-.1-.7-.2-1.1-.2-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9,3.9-1.7,3.9-3.9c0-1.3-.6-2.4-1.5-3.1L20.1,3.3c.6-1.2,1.6-1.9,2.7-1.9h0c1.1,0,2.1,.7,2.7,1.9l13.8,29.1c-.9,.7-1.5,1.8-1.5,3.1,0,2.1,1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9c-.1-2.2-1.9-3.9-4-3.9ZM3.9,37.8c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.4Zm37.7,0c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.2,31.7V7.7c1.8-.3,3.2-1.9,3.2-3.8C60.4,1.8,58.7,0,56.5,0s-3.9,1.7-3.9,3.9c0,1.9,1.4,3.5,3.2,3.8V31.7c-1.8,.3-3.2,1.9-3.2,3.8,0,2.1,1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9c-.1-1.9-1.4-3.5-3.2-3.8Zm-3.1-27.8c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4-1.1,2.4-2.4,2.4c-1.3-.1-2.4-1.1-2.4-2.4Zm2.4,33.9c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.dac3e464b4e2d683d0d3112d0d346168.svg";
export { ForwardRef as ReactComponent };